var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M47.5 25.001C47.5 37.41 37.446 47.5 24.973 47.5 12.552 47.5 2.5 37.409 2.5 25.001 2.5 12.591 12.552 2.5 24.973 2.5 37.446 2.5 47.5 12.591 47.5 25.001z","key":0}),React.createElement("path",{"d":"M37.716 19.096 22.09 34.706l-7.79-7.782","key":1})]));
}

CheckCircle.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
